// utilsモジュールからuaCheckとmq関数をインポート
import { mq } from "./modules/utils";
import anime from 'animejs/lib/anime.es.js';
import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';
// デフォルトのテーマ
import '@splidejs/splide/css/skyblue';
// import '@splidejs/splide/css/core';

import imagesLoaded from 'imagesloaded';

// import SimpleBar from 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
// import 'simplebar/dist/simplebar.css';

// 後で使用するためのbody要素への参照
const BODY = document.getElementsByTagName('body');


const hbgFunc = () =>{
  const header = document.querySelector('.js-header-class')
  const hbg = document.querySelector('.js-hbg')
  const closeHbg = document.querySelectorAll('.js-closeHbg')

  if(!hbg) return

  hbg.addEventListener('click', function(e) {
    e.preventDefault()
    header.classList.toggle('sub-menu-open')

  }, false);
  closeHbg.forEach((btn)=> {
    btn.addEventListener('click', function(e) {
      header.classList.remove('sub-menu-open')
    }, false);
  })

}

/*const preloadLink = (url) => {
  // プリロードするリソースを指定する<link>要素を作成
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = url;
  link.as = 'document';

  // 既に同じURLのプリロードが存在しないことを確認
  if (!document.head.querySelector(`link[rel="preload"][href="${url}"]`)) {
    // <head>内に<link>要素を追加
    document.head.appendChild(link);
  }
}
const customTransitionFunc = () =>{
  // すべてのリンク要素を取得
  const links = document.querySelectorAll('a');

// 各リンク要素に対してイベントリスナーを設定
  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      // リンクがページ内リンクである場合、何もせずに終了
      if ( this.getAttribute('href').indexOf('#') !== -1 ) return
      if ( this.getAttribute('target') !== null ) return

      // デフォルトのリンク動作を阻止
      event.preventDefault();

      // 特定の処理を行う関数
      BODY[0].classList.remove('open');

      // ページ遷移
      setTimeout(()=>{
        window.location.href = this.href;
      },180)
    });

    link.addEventListener('mouseover', function() {
      if (this.getAttribute('href').startsWith('#')) return
      preloadLink(this.href);
    });
  });


}*/

const originalImage = () =>{
  const Images = document.querySelectorAll('.js-originalImage')

  Images.forEach((image)=>{

    const src = image.dataset.originalimage
    const ext = image.dataset.extension
    const img = new Image()

    if(!src) return
    // console.log(image.dataset.originalimage)
    img.src = `${src + ext}`

    // console.log(img)


    img.onload = function () {
      image.setAttribute('srcset',`${src + ext}`)
    }



  })


}

function setupIntersectionObserver() {
  // ビューポートの幅を基にして、中央横20%の範囲を計算
  const viewportWidth = window.innerWidth;

  // Intersection Observerのコールバック関数
  const observerCallback = (entries) => {

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }else{
        entry.target.classList.remove('active');
      }
    });
  };

  // Intersection Observerのオプション
  const observerOptions = {
    root: null, // ビューポートをルートとする
    rootMargin: "0px -50%", // ビューポートの中心を判定基準にする
    threshold: 0 // 交差のしきい値
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // `.character`要素を監視対象として登録
  document.querySelectorAll('.character img').forEach(character => {
    observer.observe(character);
  });

}

const rotateFtanFunc = () =>{
  let frameId;
  const characters = document.querySelectorAll('.character');
  const newsBg = document.querySelector('.news-bg');
  const numCharacters = characters.length; // キャラクターの総数
  const speed = 0.0002; // 動きの速さを設定
  let startTime; // アニメーション開始時刻を保持

  function animate(timestamp) {
    if (!startTime) startTime = timestamp; // アニメーション開始時刻を設定
    const elapsed = timestamp - startTime; // 経過時間を計算

    let centerX = newsBg.clientWidth / 2; // 中心のX座標を設定
    let radius = centerX * 1.2; // 動かす半径を設定

    characters.forEach((character, index) => {
      const angle = Math.PI / 2 - index * (Math.PI * 2 / numCharacters) - speed * elapsed;
      const x = centerX - radius * Math.cos(angle); // X座標を計算（左回転）
      const y = centerX - radius * Math.sin(angle); // Y座標を計算（左回転）

      // 位置を更新
      character.style.left = `${x}px`;
      character.style.top = `${y}px`;

      // キャラクターの向きを更新（CSSのrotateを使用）
      const rotation = (angle - Math.PI / 2) * (180 / Math.PI); // ラジアンから度に変換
      character.style.transform = `rotate(${rotation}deg)`; // 左回転のためにプラスの角度を使う
    });

    frameId = requestAnimationFrame(animate); // 次のフレームをリクエスト
  }

// アニメーションを開始
  frameId = requestAnimationFrame(animate);

  let resizeTimer = false;
  // ウィンドウのリサイズ時に中心点を再計算
  window.addEventListener('resize', () => {

    // リサイズ中はタイマーを解除
    console.log('resizing');
    window.cancelAnimationFrame(frameId);
    if (resizeTimer !== false) {
      clearTimeout(resizeTimer);
    }

    resizeTimer = setTimeout(function () {
      // リサイズ完了後の処理
      adjustListItems()
      console.log('window resized!');
      startTime = null; // アニメーション開始時刻をリセット
      frameId = requestAnimationFrame(animate);
      rotateFtanFunc()

    }, 500);
  });
}

function adjustListItems() {
  const characterWrap = document.querySelector('.character-wrap');
  const baseLi = document.querySelector('.character');
  const screenWidth = window.innerWidth;
  let numberOfItems;

  // 画面幅に応じて必要な<li>の数を決定
  if (screenWidth < 1000) {
    numberOfItems = 28;
  } else if (screenWidth < 1440) {
    numberOfItems = 28;
  } else {
    numberOfItems = 36;
  }
  numberOfItems = 36;



  // 現在の<li>の数を確認
  const currentItems = characterWrap.querySelectorAll('.character').length;



  // 必要な数に調整
  if (currentItems < numberOfItems) {
    // 足りなければ複製して追加
    for (let i = currentItems; i < numberOfItems; i++) {
      const clone = baseLi.cloneNode(true); // trueで子要素も複製
      characterWrap.appendChild(clone);
    }
  } else if (currentItems > numberOfItems) {
    // 余分なら削除
    for (let i = currentItems; i > numberOfItems; i--) {
      const itemToRemove = characterWrap.querySelector('.character:last-child');
      characterWrap.removeChild(itemToRemove);
    }
  }

}

function startSlider() {
  const items = document.querySelectorAll('.rotation li'); // リストアイテムを取得
  let currentIndex = 0; // 現在のインデックス

  // 全てのクラスをリセットする関数
  function resetClasses() {
    items.forEach(item => {
      item.classList.remove('reverse', 'frontSide', 'current');
    });
  }

  // スライダーを更新する関数
  function updateSlider() {
    resetClasses(); // 最初に全てのクラスをリセット

    // 現在のアイテムに .reverse を追加
    items[currentIndex].classList.add('reverse');

    // 次のインデックスを計算 (もし最後のアイテムなら最初に戻る)
    let nextIndex = (currentIndex + 1) % items.length;
    // 次のアイテムに .frontSide を追加
    items[nextIndex].classList.add('frontSide');

    // 0.6秒後に .reverse と .frontSide を削除し、次のアイテムに .current を追加
    setTimeout(() => {
      resetClasses(); // クラスをリセット
      items[nextIndex].classList.add('current'); // 次のアイテムを現在のアイテムとして設定
      currentIndex = nextIndex; // インデックスを更新
    }, 1000); // 0.6秒後に実行
  }

  // 5秒ごとにスライダーを更新
  setInterval(updateSlider, 5000);
};

function slideInAnimationFunc(){

  // `slide-in`クラスを持つすべての要素を取得
  const slideInElements = document.querySelectorAll('.js-slide-in');

  // Intersection Observerのコールバック関数
  const observerCallback = (entries) => {

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        anime({
          targets: entry.target,
          // translateY: [0, 20],
          // opacity : [1,0],
          easing: 'easeOutCubic',
          duration: 300,
          complete : ()=>{

          }
        })
        observer.unobserve(entry.target)
      }
    });
  };

  // Intersection Observerのオプション
  const observerOptions = {
    root: null, // ビューポートをルートとする
    rootMargin: "-15% 15%", // ビューポートの中心を判定基準にする
    threshold: [0,0.5,1] // 交差のしきい値
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 各要素に対してループ処理
  slideInElements.forEach(function(el) {
    // 新しいspan要素を作成
    const wrapperSpan = document.createElement('span');
    const bgSpan = document.createElement('span');

    // 現在の要素の親ノードに新しいspanを挿入
    el.parentNode.insertBefore(wrapperSpan, el);

    // 新しいspanの中に元の要素を移動
    wrapperSpan.classList.add('slide-in-wrap')
    wrapperSpan.appendChild(el);
    wrapperSpan.appendChild(bgSpan)

    observer.observe(wrapperSpan);




  });
}

function splideFunc(){

  const splide = new Splide( '.splide',{
    perPage: window.innerWidth < 1000 ? 3 : 4,

    // type : 'loop',
    speed : 800,
    clones: 1,
    gap : '30px',
    focus : 'center',
    trimSpace: false,
    // arrows: false,
    // drag: true,
    // snap: true,
    interval: 4000,
    // pauseOnHover : false,
    // wheel : true,
    // waitForTransition : true,
    autoplay: 'pause',
    intersection: {
      inView: {
        autoplay: true,
      },
    },
    breakpoints: {
      780: {
        perPage: 1.4,
        gap : '25px',
      },
      1100: {
        perPage: 3,
        gap : '25px',
      },
    },
    // lazyLoad: 'nearby',
    // padding: '20%',
  } );
  const track = document.querySelector('.splide__track')
  splide.mount({ Intersection });


  splide.on( 'mounted move', (index) => {
    track.classList.add(index % 2 == 1 ? 'odd' : 'even')
    track.classList.remove(index % 2 == 1 ? 'even' : 'odd')
  } );
}


function scrollAnimation(elem,className){

  const targets = document.querySelectorAll(elem);

  // Intersection Observerのコールバック関数
  const observerCallback = (entries) => {
    console.log(entries)
    entries.forEach(entry => {
      anime({
        targets: entry.target.querySelectorAll('img'),
        translateY: 20,
        opacity : 0,
      })
      if (entry.isIntersecting) {
        entry.target.classList.add(className);
        anime({
          targets: entry.target.querySelectorAll('img'),
          translateY: [20, 0],
          opacity : [0,1],
          easing: 'cubicBezier(0.215, 0.61, 0.355, 1)',
          duration: 800,
          delay: anime.stagger(160),
          complete : ()=>{

          }
        })
        observer.unobserve(entry.target)
      }
    });
  };

  // Intersection Observerのオプション
  const observerOptions = {
    root: null, // ビューポートをルートとする
    rootMargin: "-15% -10%", // ビューポートの中心を判定基準にする
    threshold: [0,0.5,1] // 交差のしきい値
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  targets.forEach(function(target) {
    observer.observe(target);
  })

}

// リサイズイベントに関数を登録
// window.addEventListener('resize', adjustListItems);


function openingAnimationFunc() {
  const tl = anime.timeline({
    easing: 'easeOutExpo',
    duration: 750
  });
  const kv = document.querySelector('.kv');
  const ftan = kv.querySelector('.js-opening-ftan');
  const bg = kv.querySelector('.kv-bg');

  const imgNum = imagesLoaded('body').images.length; // 読み込んだ画像の数を格納
  let loadedImg = 0;// 現在のプログレス値を格納
  let progressNowPosition = 0;
  const Timer = setInterval(progressMonitor, 1000 / 20);

  imagesLoaded('body').on('progress', () => {
    loadedImg++;
  });



  console.log(loadedImg);


  function progressMonitor() {
    const progressPosition = (loadedImg / imgNum) * 100;
    progressNowPosition += (progressPosition - progressNowPosition) * 0.1;

    if (progressNowPosition >= 80) {
      // oncemodalMovieFunc();
      clearInterval(Timer);
      playAnime();

      // .add({
      //   targets: ftan,
      //   scale: ['1,1', '0.4, 1.2'],
      // })


    }

    const $loadingbarW = Math.round(progressNowPosition * 1.25);

    console.log(progressNowPosition)

    // $loadingbar.css('width', `${$loadingbarW}%`);

    // イージング計算を完了させる
    if (progressNowPosition > 99.9) {
      progressNowPosition = 100;
    }

    // .add({
    //   targets: '.basic-timeline-demo .el.circle',
    //   translateX: 250,
    // })
    // .add({
    //   targets: '.basic-timeline-demo .el.triangle',
    //   translateX: 250,
    // });

    // startSlider()
    // BODY[0].classList.add('open');

  }
  function playAnime(){
    tl.add({
      targets: ftan,
      translateY: ['30%', 0],
      scale: ['1.3, 0.8','1,1'],
      opacity: [0, 1],
      easing: 'spring(2, 29,  10, 3)',
      duration: 600,
      complete : ()=>{
        console.log("complete1")
      }
    })
    .add({
      targets: bg,
      translateY: ['20%', 0],
      opacity: [0, 1],
      easing: 'cubicBezier(0.215, 0.61, 0.355, 1)',
      duration: 1200,
      complete : ()=>{
        console.log("complete2")
      }
    },'1200')
    .add({
      targets: '.header',
      translateY: ['-120%', 0],
      opacity: [0, 1],
      easing: 'cubicBezier(0.215, 0.61, 0.355, 1)',
      duration: 1200,
      complete : ()=>{
        console.log("complete3")
        BODY[0].classList.add('open');
        startSlider()
      }
    },'1600')
    .add({
      targets: '.header',
      complete : ()=>{
        console.log("complete4")
        BODY[0].classList.add('animation')
      }
    },'1100')


  }
}



// アニメーションを停止するには以下のコードを実行
// cancelAnimationFrame(frameId);

if(mq('sp')){
  document.querySelector('.twitter-timeline').dataset.height = 345
}

// DOMが完全にロードされたらbodyに'open'クラスを追加
document.addEventListener("DOMContentLoaded", () => {
  if(BODY[0].classList.contains('open')) return


  // scrollBar()
  // customTransitionFunc();
  hbgFunc()
  adjustListItems()
  originalImage()
  // rotateFtanFunc()
  slideInAnimationFunc()
  scrollAnimation('.js-about-ftan','showing')
  openingAnimationFunc();
  // console.log("DOMContentLoaded")
});

window.addEventListener('load', () => {
// Intersection Observerの設定を実行
  setupIntersectionObserver();
  splideFunc()
});




/*if (document.readyState === 'loading'){
  document.addEventListener("DOMContentLoaded", onContentLoaded);
} else {
  onContentLoaded();
}*/

/*window.addEventListener('pageshow', () => {
  if(performance.getEntriesByType("navigation")[0].type === 'back_forward'){
    BODY[0].classList.add('open');
    scrollBar()
    customTransitionFunc();
    hbgFunc()
    console.log('back_forward')
  }
});*/

// ウィンドウがロードされたら高さを揃える
// window.addEventListener("load", () => {
//   matchHeightFunc(false, 1200);
// });

